export const sourceTypeConst = {
    AzureBlobFS: 'AzureBlobFS',
};

export const formatConst = {
    CosmosDB: 'document',
    Delimited: 'delimited',
    SQL: 'table',
    Delta: 'delta',
    Parquet: 'parquet',
    Avro: 'avro',
    JSON: 'json',
    ORC: 'orc',
    XML: 'xml',
    Excel: 'excel',
    CDM: 'cdm',
    Cassandra: 'cassandratable',
};


export const manifestConst = 'manifest';

export const storeConst = {
    CosmosDB: 'cosmosDB',
    SQL: 'sqlserver',
    MySQL: 'mysql',
    Postgres: 'postgres',
    SynapseAnalytics: 'synapseanalytics',
    Snowflake: 'snowflake',
    Cassandra: 'cassandra'
};
